import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnomedCodes } from '../../models/dictation.interface';

@Component({
    standalone: false,
    selector: 'cva-snomed-codes-dailog',
    templateUrl: './snomed-codes-dailog.component.html',
    
})
export class SnomedCodesDailogComponent {
  selectedValue = "";
  constructor(public dialogRef: MatDialogRef<SnomedCodesDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, codes: Array<SnomedCodes> }) {
  }


  closeDialog() {
    this.dialogRef.close(this.selectedValue);
  }
}
